import { defineMessages } from 'react-intl';

export default defineMessages({
    LeadTraveller: {
        id: 'qnb.spt.SgSptMedicalConditions.LeadTraveller',
        defaultMessage: '{name} (Lead Traveller)'
    },
    DateOfBirth: {
        id: 'qnb.spt.SgSptMedicalConditions.DateofBirth',
        defaultMessage: 'Date of birth: {dateOfBirth}'
    },
    Address: {
        id: 'qnb.spt.SgSptMedicalConditions.Address',
        defaultMessage: 'Address: {address}'
    },
    MedicalConditions: {
        id: 'qnb.spt.SgSptMedicalConditions.MedicalConditions',
        defaultMessage: 'Medical conditions declared:'
    },
    NoMedicalConditions: {
        id: 'qnb.spt.SgSptMedicalConditions.NoMedicalConditions',
        defaultMessage: 'No medical conditions declared'
    },
    WaitingList: {
        id: 'qnb.spt.SgSptMedicalConditions.WaitingList',
        defaultMessage: '(On a waiting list)'
    }
});
